<script>

    /**
     * Contenedor de sección para vistas de información.
     *
     * Props:
     *   subtitle  — etiqueta pequeña gris encima del título (siempre visible)
     *   title     — título principal (is-4). Cuando está presente muestra el
     *               header con layout flex y el slot "tag" a la derecha.
     *
     * Slots:
     *   tag       — badge/tag que aparece a la derecha del header (requiere title)
     *   default   — contenido libre dentro del panel interior (notification)
     */

    export let subtitle = ""
    export let title = ""

</script>

<style>
    .info-card-box {
        border: 1px solid var(--border-subtle);
        background-color: var(--bg-card);
        border-radius: var(--radius-card);
    }

    .info-card-inner {
        border: 1px solid var(--border-inner) !important;
        border-radius: var(--radius-inner);
    }
</style>

<div class="box is-shadowless p-5 mb-4 info-card-box">

    {#if title}
        <div class="is-flex is-justify-content-space-between is-align-items-center mb-4">
            <div>
                {#if subtitle}
                    <p class="heading has-text-grey mb-1">{ subtitle }</p>
                {/if}
                <h2 class="title is-4 mb-0">{ title }</h2>
            </div>
            <slot name="tag" />
        </div>
    {:else if subtitle}
        <p class="heading has-text-grey mb-3">{ subtitle }</p>
    {/if}

    <div class="notification is-white p-5 info-card-inner">
        <slot />
    </div>

</div>
